import clsx from 'clsx';
import { Anchor, Referenz } from 'components/atoms';
import React from 'react';
import { ÄhnlichesUnternehmen } from 'types/unternehmen';

import css from './ÄhnlicheUnternehmen.module.scss';

interface ÄhnlicheUnternehmenProps
{
  data: ÄhnlichesUnternehmen[];
}

const ÄhnlicheUnternehmen: React.FC<ÄhnlicheUnternehmenProps> = (props) =>
{
  const { data } = props;
  
  function renderItem(item: ÄhnlichesUnternehmen)
  {
    return (
      <li key={item.ref.id} className={css.itemContainer}>
        <Referenz data={item.ref}>
          {({ href, ref }) => (
            <Anchor
              href={href}
              className={css.item}
            >
              <span className={css.name}>{ref.name}</span>
              {item.adresse  ?
                (<span className={css.ort}>{`${item.adresse.plz} ${item.adresse.ort}`}</span>)
                :
                (<span className={css.ort}>{`${item.gemeinde.politischerBezirk} ${item.gemeinde.bundesland}`}</span>)
              }
            </Anchor>
          )}
        </Referenz>
      </li>
    );
  }

  return (
    <div className={css.container}>
      <ul className={clsx('scrollbars', css.grid)}>
        {data.map((u) => renderItem(u))}
      </ul>
    </div>
  );
};

export default ÄhnlicheUnternehmen;
